"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_point_type_enum_1 = require("../../model/data-point-type.enum");
/**
 * @author gevorg.avetisyan on 2/10/2017.
 */
var DataPointMeta = /** @class */ (function () {
    function DataPointMeta(id, name, type, dataFormatType, disaggregationGroupId, disaggregationIds, disaggregationGroupIds, disaggregationDataPointRelations, displayName, readOnly, isOutput) {
        if (isOutput === void 0) { isOutput = false; }
        this.id = id;
        this.name = name;
        this.type = type;
        this.dataFormat = dataFormatType;
        this.disaggregationIds = disaggregationIds;
        this.disaggregationGroupId = disaggregationGroupId;
        this.disaggregationGroupIds = disaggregationGroupIds;
        this.disaggregationDataPointRelations = disaggregationDataPointRelations;
        this.displayName = displayName;
        this.readOnly = readOnly;
        this.isOutput = isOutput;
    }
    // getOrderId(): number {
    //     return this.orderId;
    // }
    //>> UI
    DataPointMeta.prototype.hasPeriodicity = function () {
        if (this.type === data_point_type_enum_1.DataPointType.BASELINE) {
            return false;
        }
        else if (this.id === -1 || this.id === -2) {
            return false;
        }
        return true;
        // return (this.type != DataPointType.BASELINE || this.id !== -1);
    };
    DataPointMeta.prototype.rowspan = function () {
        return this.hasPeriodicity() ? 1 : 2;
    };
    DataPointMeta.prototype.isComment = function () {
        if (this.dataFormat.comment) {
            return true;
        }
        return false;
    };
    DataPointMeta.prototype.getDisplayName = function () {
        return this.displayName;
    };
    DataPointMeta.prototype.getName = function (currentLanguageId) {
        return this.name.getValue(currentLanguageId);
    };
    return DataPointMeta;
}());
exports.DataPointMeta = DataPointMeta;
//# sourceMappingURL=data-point-meta.model.js.map